module.exports = __webpack_public_path__ + "static/media/watcc_logo_w.98555fc4.png";